export enum RouteCategories {
  USERS = "users",
  LISTINGS = "listings",
  TRANSACTIONS = "transactions",
  REPORTS = "reports",
  ADMINS = "admins",
  ROLES = "roles",
  CATEGORIES = 'categories',
  SERVICES = 'services',
  TERMS = 'terms',
  POLICY = 'policy',
  BOTS = 'bots',
  BOTS_BILLING = 'bots-billing',
  PLATFORM_SETTINGS = 'platform-settings',
  EVENTS = 'events',
  RECOMMENDED_ACCOUNTS = 'recommended-accounts',
  FEED_PERFORMANCE = 'feed-performance',
  AI_MODERATION = 'ai-moderation',
}
